import { SET_IMAGE, SET_NAME, SET_FORMAT, SET_DIMENSION, SET_PROPORTIONS } from '../constants/imageConstants';

export const imageInitState = {
    image: '',
    format: '',
    height: 0,
    width: 0,
    name: '',
};

const imageReducer = (state: any, action: any) => {
    switch (action.type) {
        case SET_IMAGE:
            return {
                ...state,
                image: action.image
            }
        case SET_NAME:
            return {
                ...state,
                name: action.name
            }
        case SET_FORMAT:
            return {
                ...state,
                format: action.format
            }
        case SET_DIMENSION:
            return {
                ...state,
                height: action.height,
                width: action.width
                
            }
        case SET_PROPORTIONS:
            return {
                ...state,
                isProperties: action.isProperties
            }
        default:
            return { ...state };
    }
};

export default imageReducer;